<template>
  <div class="card mb-3">
    <div class="card-header d-flex">
      <p class="lead text-uppercase m-0">{{ 'Tags' | translate }}</p>
    </div>
    <div class="card-body row">
      <div class="col-12 col-md-8 offset-md-2">
        <div class="mb-4">
          {{ 'Public tags' | translate }}
          <VueTagsInput
            class=""
            v-model="newTagAll"
            :placeholder="$t('Add') + ' tag'"
            :tags="tsa"
            :allow-edit-tags="true"
            @before-saving-tag="changeTag"
            @tags-changed="(newTags) => (tsa = newTags)"
          />
          <small class="text-muted">
            {{ 'Displaying publicly on your page' | translate }}.
          </small>
        </div>

        <div class="mb-4">
          {{ 'Tags assigned to this product' | translate }}
          <VueTagsInput
            class=""
            v-model="newTag"
            :placeholder="$t('Add') + ' tag'"
            :max-tags="5"
            :tags="ts"
            :add-only-from-autocomplete="true"
            :autocomplete-items="autocomplete"
            @before-saving-tag="changeTag"
            @tags-changed="(newTags) => (ts = newTags)"
            :disabled="tsa.length === 0"
          />
          <small class="text-muted">
            {{ 'Choose from public tags' | translate }}.
          </small>
        </div>
        <hr />
        <div class="mb-4">
          {{ 'Private tags' | translate }}
          <VueTagsInput
            class=""
            v-model="newTagInternal"
            :autocomplete-items="internalTagsAutocomplete"
            :placeholder="$t('Add') + ' tag'"
            :tags="its"
            @tags-changed="(newTags) => (its = newTags)"
          />
          <small class="text-muted">
            {{ 'Only for internal use' | translate }}.
            {{ 'They can help you stay organised' | translate }}.
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: {
    VueTagsInput,
  },
  props: ['course', 'tagsAll'],
  data() {
    return {
      editing: false,
      newTag: '',
      newTagAll: '',
      newTagInternal: '',
      active: this.course.tags || [],
      all: this.tagsAll || [],
      internalTags: this.course.tags_internal || [],
    }
  },
  computed: {
    its: {
      get() {
        return this.internalTags.map((t) => ({
          ...t,
          text: t.name,
          visible: false,
        }))
      },
      set(value) {
        axios
          .post(`/home/tags/internal`, {
            tags: value,
            course_id: this.course.id,
          })
          .then(({ data }) => {
            this.internalTags = data
            this.success(this.$t('Saved'))
          })
          .catch(this.handleError)
      },
    },
    ts: {
      get() {
        return this.active.map((t) => ({
          ...t,
          text: t.name,
        }))
      },
      set(value) {
        axios
          .post(`/home/tags/attach`, {
            tags: value,
            course_id: this.course.id,
          })
          .then(({ data }) => {
            this.active = data
            this.success(this.$t('Saved'))
          })
          .catch(this.handleError)
      },
    },
    tsa: {
      get() {
        return this.all.map((t) => ({
          ...t,
          text: t.name,
        }))
      },
      set(value) {
        axios
          .post('/home/tags', {
            tags: value,
          })
          .then(({ data }) => {
            this.all = data
            this.success(this.$t('Saved'))
          })
          .catch(this.handleError)
      },
    },
    internalTagsAutocomplete() {
      return _.get(this.course, 'page.tags_internal', []).map((t) => ({
        text: t.name,
      }))
    },
    autocomplete() {
      return this.tsa.map((t) => ({
        text: t.name,
      }))
    },
  },
  methods: {
    success(msg) {
      iziToast.success({
        title: 'OK',
        message: msg,
        position: 'bottomLeft',
      })
    },
    handleError(error) {
      if (error.response && error.response.status === 419) {
        this.$root.$emit(
          'flash',
          this.$t('Your session has expired - please reload'),
          'warning',
        )
      } else {
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
        console.error(error)
      }
    },
    handleAddTag() {
      if (
        this.newTag !== '' &&
        !this.all.filter((tag) => tag.name === this.newTag).length
      ) {
        axios
          .post('/home/tags', {
            name: this.newTag,
          })
          .then((response) => {
            this.all.push(response.data)
            this.newTag = ''
            this.success(this.$t('Added'))
          })
          .catch(this.handleError)
      }
    },
    handleAddToCourse(selectedTag) {
      if (!this.active.filter((tag) => tag.name === selectedTag.name).length) {
        axios
          .put(`/home/tags/${selectedTag.id}/attach`, {
            course_id: this.course.id,
          })
          .then((response) => {
            this.active.push(response.data)
            this.success(this.$t('Added'))
          })
          .catch(this.handleError)
      }
    },
    handleRemoveFromCourse(selectedTag) {
      axios
        .put(`/home/tags/${selectedTag.id}/detach`, {
          course_id: this.course.id,
        })
        .then((response) => {
          this.active = this.active.filter(
            (tag) => tag.name !== selectedTag.name,
          )
          this.success(this.$t('Removed'))
        })
        .catch(this.handleError)
    },
    changeTag(value) {
      return this.handleRenameTag(value.tag)
    },
    handleRenameTag(selectedTag) {
      axios
        .put(`/home/tags/${selectedTag.id}`, selectedTag)
        .then((response) => {
          this.active = this.active.map((t) => {
            if (t.id === response.data.id) {
              return response.data
            }
            return t
          })
          this.all = this.all.map((t) => {
            if (t.id === response.data.id) {
              return response.data
            }
            return t
          })
          this.success(this.$t('Changed'))
        })
        .catch(this.handleError)
    },
    edit(selectedTag, index) {
      this.$set(this.all, index, {
        ...selectedTag,
        editing: !selectedTag.editing,
      })
    },
    handleDeleteTag(selectedTag) {
      axios
        .delete(`/home/tags/${selectedTag.id}`)
        .then((response) => {
          this.active = this.active.filter(
            (tag) => tag.name !== selectedTag.name,
          )
          this.all = this.all.filter((tag) => tag.name !== selectedTag.name)
          this.success(this.$t('Deleted'))
        })
        .catch(this.handleError)
    },
  },
}
</script>
